'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const clsx = require('clsx');
const React = require('react');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const clsx__default = /*#__PURE__*/_interopDefault(clsx);
const React__default = /*#__PURE__*/_interopDefault(React);

const secondaryNavTitle = "_secondary-nav-title_1uwk4_1";
const styles = {
	secondaryNavTitle: secondaryNavTitle
};

const SecondaryNavTitle = ({ value, className }) => {
  return React__default.default.createElement("h2", { className: clsx__default.default(className, styles.secondaryNavTitle), "data-zds": true }, value);
};

exports.SecondaryNavTitle = SecondaryNavTitle;
//# sourceMappingURL=SecondaryNavTitle.cjs.js.map
